(function () {
    function isMobile() {
        return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    function mount() {
        document.querySelectorAll('.wp-block-ow-feature-block-tabs').forEach(function (tabsContainer) {
            var tabs = tabsContainer.querySelectorAll('.tab-button');
            var tabsData = tabsContainer.getAttribute('data-tabs');
            var showOnMobile = tabsContainer.getAttribute('data-show-on-mobile') === 'true';
            var tabsBehaviour = tabsContainer.getAttribute('data-tabs-behaviour') === 'true';

            if (!tabsData) return;

            try {
                var tabsConfig = JSON.parse(tabsData);
            } catch (e) {
                return;
            }

            // Check if should display on mobile
            if (isMobile() && !showOnMobile) {
                tabsContainer.style.display = 'none';
                return;
            }

            var activeIndex = 0;
            var shouldScroll = false;

            // Initialize: set scroll margin for sections if tabsBehaviour is false
            if (!tabsBehaviour) {
                tabsConfig.forEach(function (tab) {
                    if (tab.selector) {
                        var element = document.querySelector('.' + tab.selector);
                        if (element) {
                            element.style.scrollMarginTop = '100px';
                        }
                    }
                });
            } else {
                // If tabsBehaviour is true, initially hide all sections except the first
                tabsConfig.forEach(function (tab, idx) {
                    if (tab.selector) {
                        var element = document.querySelector('.' + tab.selector);
                        if (element && idx !== 0) {
                            element.style.display = 'none';
                        }
                    }
                });
            }

            // Function to update active tab and content
            function updateActiveTab(index) {
                // Update button classes
                tabs.forEach(function (btn, idx) {
                    if (idx === index) {
                        btn.classList.add('active');
                    } else {
                        btn.classList.remove('active');
                    }
                });

                // Update content visibility or scroll
                tabsConfig.forEach(function (tab, idx) {
                    if (!tab.selector) return;

                    var element = document.querySelector('.' + tab.selector);
                    if (!element) return;

                    if (tabsBehaviour) {
                        // Show/hide behavior
                        element.style.display = (idx === index) ? 'block' : 'none';
                    } else {
                        // Scroll behavior - only scroll when user clicks, not on initial load
                        if (idx === index && shouldScroll) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }
                });
            }

            // Add click handlers to tab buttons
            tabs.forEach(function (btn, index) {
                btn.addEventListener('click', function () {
                    shouldScroll = true;
                    activeIndex = index;
                    updateActiveTab(index);
                });
            });

            // Initialize first tab
            updateActiveTab(activeIndex);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mount);
    } else {
        mount();
    }
})();

